import type { HomepageModel } from '~/models'

export function useNavigationGroup() {
  const route = useRoute()
  const siteStore = useSiteStore()

  // Keep this reactive in case the store updates
  const navigationGroups = computed(
    () => siteStore.getHeaderNavigationGroups?.() || []
  )

  const activeGroup = computed(() => {
    let path = route.path || '/'
    const groups = navigationGroups.value

    if (route.query?.itemid) {
      const itemId = route.query?.itemid as string
      let pageRouteInfo = siteStore.getPage(path, itemId, siteStore.collection)
      if (pageRouteInfo) {
        path = pageRouteInfo.path
      }
    }

    // Exact match first
    const exact = groups.find(
      (g: any) => g.homepageUrl && path === g.homepageUrl
    )
    if (exact) return exact

    // Prefix match
    const pref = groups.find(
      (g: any) =>
        g.homepageUrl &&
        path.startsWith(
          g.homepageUrl + (g.homepageUrl.endsWith('/') ? '' : '/')
        )
    )
    if (pref) return pref

    return groups[0]
  })

  const navigationItems = computed(() => activeGroup.value?.items || siteStore.getHeaderNavigationItems())

  const homepageItem = computed<HomepageModel | undefined>(() => {
    const codename = activeGroup.value?.homepageCodename
    if (!codename) return undefined

    return siteStore.getLinkedItem?.(codename) as HomepageModel | undefined
  })

  return {
    activeGroup,
    navigationItems,
    homepageItem
  }
}
